import React, { useEffect, useState } from "react";

import { Link, useParams } from "react-router-dom";
import { Col, Row, Spinner } from "react-bootstrap";

import { useDispatch, useSelector } from "react-redux";

import { PatientCard } from "./PatientCard";
import { getPatientList } from "../../../../redux/actions/dbactions/pateints";
import { Header } from "../../../Header";
import { Icon } from "@iconify/react/dist/iconify.js";
import { getSession } from "../../../../redux/actions/authActions";
import { getProfileSession } from "../../../../redux/actions/dbactions/profileActions";
import axios from "axios";
import { BaseUrl } from "../../../../redux/config";
import { toast } from "react-toastify";

export const ProfileListexplore = () => {
  const dispatch = useDispatch();
  const { serviceID } = useParams();

  const cartItems = useSelector((state) => state?.cart?.cartItems);
  const { profileData } = getProfileSession();

  const { patientsList, isLoading, currentData, bookingData } = useSelector(
    (state) => state.patients
  );

  const patientsLists = patientsList.usr?.svcUserProfile || [];
  const [selectedColor, setSelectedColor] = useState(null);
  const [isDisabled, setIsDisabled] = useState(null);
  const [sessionUrl, setSessionUrl] = useState("");

  const HandleClick = (id) => {
    setSelectedColor(selectedColor === id ? null : id);
    setIsDisabled(isDisabled === id ? null : id);
  };
  useEffect(() => {
    dispatch(getPatientList());
  }, [dispatch, serviceID]);

  useEffect(() => {
    if (sessionUrl) {
      window.location.href = sessionUrl;
    }
  }, [sessionUrl]);

  const total =
    cartItems?.length > 0 &&
    cartItems[0]?.svcsc_cart_jsn?.service_order_line?.reduce(
      (sum, item) => sum + Number(item?.svc_price_amt),
      0
    );

  const handleSubmitPay = async (patientId) => {
    const { token, user_profile_id } = getSession();
    const postData = {
      ord_svc_date: cartItems[0]?.svcsc_cart_jsn?.ord_svc_date,
      ord_svc_time: cartItems[0]?.svcsc_cart_jsn?.ord_svc_time,
      order_dte_tsp: cartItems[0]?.svcsc_cart_jsn?.order_dte_tsp,
      order_tot_amt: total,
      order_tot_qty: cartItems[0]?.svcsc_cart_jsn?.service_order_line?.length,
      order_tot_tax: 0,
      order_tot_fees: 0,
      order_svcf_id: serviceID,
      user_profile_id: cartItems[0]?.user_profile_id,
      order_svc_user_id: patientId,
      order_ship_to_id: 2,
      order_ship_instructions: "",
      order_bill_to_id: 2,
      order_status_id: 1,
      sys_user_id: user_profile_id,
      role_id: profileData?.role_id,
      sys_source_ip: "192.168.2.2",
      sys_crte_tsp: cartItems[0]?.svcsc_cart_jsn?.sys_crte_tsp,
      sys_last_updte_tsp: cartItems[0]?.svcsc_cart_jsn?.sys_last_updte_tsp,
      sys_ord_active_yn: "Y",
      service_order_line: cartItems[0]?.svcsc_cart_jsn?.service_order_line,
    };

    try {
      let response = await axios.post(`${BaseUrl}pay/ps`, postData, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      setSessionUrl(response?.data?.session_url);
      return response.data;
    } catch (err) {
      toast.error(
        `${
          err.response?.data?.usr?.message ||
          err.response?.data?.message ||
          err.response?.message ||
          err.message
        }`
      );
    }
  };
  localStorage.removeItem("newPatient");
  return (
    <div>
      <Header
        pageTitle={`Explore > Patient Lists`}
        icon={<Icon icon="material-symbols:explore-outline" />}
      />

      <div className="px-[0.75rem] sm:px-8 mt-4 flex items-center justify-between mb-3">
        <h5 className="text-base sm:text-[26px] w-full whitespace-nowrap m-0">
          My Patient List
        </h5>
        <div className="w-fit whitespace-nowrap">
          <Link
            to={`/dashboard/explore/add-patient`}
            className=" !text-xs sign_btn"
          >
            + Add A New Patient
          </Link>
        </div>
      </div>
      {isLoading ? (
        <div className="text-center">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : null}
      <Row className="sm:!px-4 m-0">
        {patientsLists.length > 0 ? (
          patientsLists.map((item, index) => (
            <Col className="mb-3" lg={4} md={6} key={index}>
              <PatientCard
                data={item}
                HandleClick={() => HandleClick(item.svcuser_profile_id)}
                selectedColor={selectedColor}
                isDisabled={isDisabled}
                currentData={currentData}
                bookingData={bookingData}
                handleSubmitPay={() => handleSubmitPay(item.svcuser_profile_id)}
              />
            </Col>
          ))
        ) : (
          <Col>
            <p className="text-center">No Patients found</p>
          </Col>
        )}
      </Row>
      {/* <DeleteModal
        show={show}
        handleClose={() => setShow(false)}
        selectedTitle={selectedTitle}
        handleDelete={handleDelete}
      />
      <AddModal
        show={addmodal}
        onHide={() => setAddmodal(false)}
        setRefresh={setRefresh}
        setAddmodal={setAddmodal}
        serviceid={facilityId}
      />
      <EditModal
        show={editmodal}
        onHide={() => setEditmodal(false)}
        setRefresh={setRefresh}
        setEditmodal={setEditmodal}
        serviceid={facilityId}
      /> */}
    </div>
  );
};
